import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AliasKey, Fabric, FabricSearchCommand } from '../../models/item/fabric';

import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({ providedIn: 'root' })
export class FabricProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/fabric';

  public getFabrics(): Observable<ApiResponse<Fabric[]>> {
    return this.httpClient.get<ApiResponse<Fabric[]>>(this.baseUrl + '/all');
  }

  public searchFabric(command: FabricSearchCommand, matchAny = false): Observable<ApiResponse<PaginatedApiResponse<Fabric>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Fabric>>>(this.baseUrl + '/search?matchAny=' + matchAny, command);
  }

  public updateAliases(id: string, aliases: AliasKey[]): Observable<ApiResponse<void>> {
    return this.httpClient.patch<ApiResponse<void>>(this.baseUrl + '/' + id + '/aliases', aliases);
  }

  public getFabricByItemCode(itemCode: string): Observable<ApiResponse<Fabric>> {
    return this.httpClient.get<ApiResponse<Fabric>>(this.baseUrl + '/fabric-code/' + encodeURIComponent(itemCode));
  }

  public getFabricCodesBatch(fabricCodes: string[]): Observable<ApiResponse<Fabric[]>> {
    return this.httpClient.post<ApiResponse<Fabric[]>>(this.baseUrl + '/fabric-code/batch', fabricCodes);
  }
}
